/// <amd-module name="Wit/WorkItemForm/Header/WorkItemFormNavBar" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { usePageContext } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { HeaderTitle } from "VSSUI/Header";
import { IWorkItemsHubNavData } from "Wit/Common/WorkItemsHubNavDataService/IWorkItemsHubNavDataService";
import * as Resources from "Wit/WorkItemForm/Resources";
import { getWorkItemHubUrl } from "../Common/RoutingUtils";

export interface IWorkItemFormNavBarProps {
    onNavigateNext: () => void;
    onNavigatePrevious: () => void;

    navigationData: IWorkItemsHubNavData;
}

export function WorkItemFormNavBar({ onNavigateNext, onNavigatePrevious, navigationData }: IWorkItemFormNavBarProps) {
    const { tabName, workItemIds, selectedItemIndexInVisibleList, selectedIndexScrollTopValue } = {
        ...navigationData
    };

    const pageContext = usePageContext();

    return (
        <div className="work-item-form-nav-bar flex-row flex-grow flex-center">
            <HeaderTitle className="flex-row flex-center padding-right-8">{tabName ?? Resources.WorkItems} </HeaderTitle>
            <div className="form-nav-bar-divider margin-horizontal-8" />
            <Button
                iconProps={{ iconName: "Reply" }}
                subtle
                text={Resources.BackToWorkItems}
                onClick={() => FastPageSwitch(pageContext, getWorkItemHubUrl(pageContext), false)}
            />
            {selectedItemIndexInVisibleList !== undefined && workItemIds && workItemIds.length !== 0 && (
                <div className="flex-row flex-grow justify-end flex-center">
                    <div className="padding-right-8">
                        {format(Resources.SelectedWorkItem, selectedItemIndexInVisibleList + 1, workItemIds.length)}
                    </div>
                    <Button
                        ariaLabel={Resources.PreviousWorkItem}
                        subtle={true}
                        iconProps={{ iconName: "Up" }}
                        onClick={onNavigatePrevious}
                        disabled={selectedItemIndexInVisibleList === selectedIndexScrollTopValue}
                        tooltipProps={{ text: Resources.PreviousWorkItem }}
                    />
                    <Button
                        ariaLabel={Resources.NextWorkItem}
                        subtle={true}
                        iconProps={{ iconName: "Down" }}
                        onClick={onNavigateNext}
                        disabled={selectedItemIndexInVisibleList + 1 === workItemIds.length}
                        tooltipProps={{ text: Resources.NextWorkItem }}
                    />
                </div>
            )}
        </div>
    );
}
